import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { values, pick } from 'lodash';
import { bindActionCreators } from 'redux';
import {
  HelpBlock, ControlLabel, FormControl,
  FormGroup, Button, Checkbox,
} from 'react-bootstrap';
import s from '../../../redux/selectors';
import a from '../../../redux/actions';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';

const SignupForm = ({
  t, user, signup, patch,
  password, passwordConfirm,
  signupFormValidations, signupFormErrors,
}) => (
  <div id="signup_form">
    <FormGroup
      validationState={signupFormErrors.errEmailNonUnique ? 'error' : (signupFormValidations.email ? 'success' : null)}
    >
      <ControlLabel>{t('Email')}*</ControlLabel>
      <FormControl
        id="signup_form__email"
        componentClass="input"
        type="text"
        value={user.email}
        onChange={e => patch({ user: { email: e.target.value } })}
      />
      {signupFormErrors.errEmailNonUnique && <HelpBlock>{t('A user with this email already exists.')}</HelpBlock>}
    </FormGroup>
    <FormGroup
      validationState={signupFormValidations.firstName ? 'success' : null}
    >
      <ControlLabel>{t('First name')}*</ControlLabel>
      <FormControl
        id="signup_form__first_name"
        componentClass="input"
        type="text"
        value={user.firstName}
        onChange={e => patch({ user: { firstName: e.target.value } })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>{t('Last name')}</ControlLabel>
      <FormControl
        id="signup_form__last_name"
        componentClass="input"
        type="text"
        value={user.lastName}
        onChange={e => patch({ user: { lastName: e.target.value } })}
      />
    </FormGroup>
    <FormGroup
      validationState={signupFormValidations.password ? 'success' : null}
    >
      <ControlLabel>{t('Password')}</ControlLabel>
      <FormControl
        id="signup_form__password"
        componentClass="input"
        type="password"
        value={password}
        onChange={e => patch({ auth: { password: e.target.value } })}
      />
      <HelpBlock>{t('Must be 8-64 characters long')}</HelpBlock>
    </FormGroup>
    <FormGroup
      id="signup_form__password_confirm_group"
      validationState={signupFormValidations.passwordConfirm ? 'success' : null}
    >
      <ControlLabel>{t('Confirm password')}</ControlLabel>
      <FormControl
        id="signup_form__password_confirm"
        componentClass="input"
        type="password"
        value={passwordConfirm}
        onChange={e => patch({ auth: { passwordConfirm: e.target.value } })}
      />
      {signupFormValidations.passwordConfirm && <HelpBlock>{t('Passwords match!')}</HelpBlock>}
    </FormGroup>
    <FormGroup>
      <Checkbox
        id="signup_form__public"
        checked={user.public}
        onChange={e => patch({ user: { public: e.target.checked } })}
      >{t('Share my footprint and pledges publicly')}</Checkbox>
    </FormGroup>
    <FormGroup
      id="signup_form__tac_group"
      validationState={signupFormValidations.agreedToTermsAndConditions ? 'success' : 'warning'}
    >
      <Checkbox
        id="signup_form__tac"
        checked={signupFormValidations.agreedToTermsAndConditions}
        onChange={e => patch({ ui: { agreedToTermsAndConditions: e.target.checked ? (new Date().toISOString()) : '' } })}
      >
        {t('I agree to the ')}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://coolclimate-calculator-ui.firebaseapp.com/assets/coolclimate-terms-of-use.pdf"
        >{t('terms and conditions')}</a>.
      </Checkbox>
    </FormGroup>
    <Button
      id="signup_form__submit"
      disabled={values(signupFormValidations).some(v => !v)}
      onClick={signup}
    >{t('Submit')}</Button>
  </div>
);

SignupForm.propTypes = {
  t: PropTypes.func.isRequired,
  signup: PropTypes.func.isRequired,
  patch: PropTypes.func.isRequired,
  user: types.User.isRequired,
  password: PropTypes.string.isRequired,
  passwordConfirm: PropTypes.string.isRequired,
  signupFormValidations: types.SignupFormValidations.isRequired,
  signupFormErrors: types.SignupFormErrors.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'user',
  'password',
  'passwordConfirm',
  'signupFormErrors',
  'signupFormValidations',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'signup',
    'patch',
  ]),
  dispatch,
);

export default wrap(
  withT('auth'),
  connect(mapStateToProps, mapDispatchToProps)(SignupForm),
);

